import styled from 'styled-components';
import { LabelButtonStyle } from '../Buttons/style';
import { FontSize14 } from '../fonts';
import { ButtonGradient } from '../Buttons';

export const CallMeBackButtonContainer = styled.div`
    width: 200px;
    margin-left: 20px;
`;

export const CallMeBackButton = styled(ButtonGradient)`
`;

export const CallMeBackButtonLabel = styled(LabelButtonStyle)`
    ${FontSize14};
`;